<script type="text/ecmascript-6">
    import DesignerQuestionTechnicalDrainage from "../DesignerQuestionTechnicalDrainage.vue";

    export default {
        mixins: [
            DesignerQuestionTechnicalDrainage
        ],
        computed: {
            panel_required(){
                return false;
            },
        },
    }
</script>
